import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layouts/header/header.component';
import { MaterialModule } from './shared/material.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  DonorComponent } from './modules/donor/donor.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { EntiretableComponent } from './modules/entiretable/entiretable.component';


import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { ArchivedtableComponent } from './modules/archivedtable/archivedtable.component';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    DonorComponent,

    EntiretableComponent,

    ArchivedtableComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    MaterialModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,    

    // PdfViewerModule
  ],
  exports: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  providers: [{provide : APP_BASE_HREF, useValue : '/LCAEPosting'}],
  bootstrap: [AppComponent],
  entryComponents:[]
})
export class AppModule { }
